import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { TiposDocumento } from '@rpe/registro-personas-empresas-lib/src/lib/tipos-documento/tipos-documento.model';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

// LOAD
export const entityTiposDocumentoLoadRequest = createAction(
  '[ENTITYTIPOSDOCUMENTO] Load Request'
);

export const entityTiposDocumentoLoadFailure = createAction(
  '[ENTITYTIPOSDOCUMENTO] Load Failure',
  props<{ error: Error }>()
);

export const entityTiposDocumentoLoadSuccess = createAction(
  '[ENTITYTIPOSDOCUMENTO] Load Success',
  props<{ items: TiposDocumento[] }>()
);
